import React from 'react';
import styled from 'styled-components';

import VisibilityAnimation from './VisibilityAnimation';

function Overlay({visible, children, ...props}) {
  return (
    <VisibilityAnimation show="fade-in" hide="fade-out" visible={visible}>
      <Background {...props} />
    </VisibilityAnimation>
  );
}

const Background = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(4, 4, 15, 0.3);
  z-index: 10;
`;

export default Overlay;